import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from '@ibk/shared-ui';
import { useBenefitContract } from '../../hooks/useBenefitContract';
import { useBenefitMigration } from '../../hooks/useBenefitMigration';
import { useEmissorFlow } from '../../hooks/useEmissorFlow';
import { BenefitMigrationGuard } from '../BenefitMigrationGuard';
export default function WithContractGuard({ children, redirectTo = '/beneficios' }) {
    const migration = useBenefitMigration();
    if (migration.enabled && !(migration.state.kind === 'ready' && migration.state.snapshot.phase === 'unavailable')) {
        return _jsx(BenefitMigrationGuard, { children: children });
    }
    return _jsx(OrdinaryContractGuard, { redirectTo: redirectTo, children: children });
}
function OrdinaryContractGuard({ children, redirectTo = '/beneficios' }) {
    const navigate = useNavigate();
    const { hasContract, isLoading, isError } = useBenefitContract();
    const { isEmissorFlow, isLoading: isEmissorLoading } = useEmissorFlow();
    const loading = isLoading || isEmissorLoading;
    const isAllowed = isEmissorFlow || (!isError && hasContract);
    useEffect(() => {
        if (!loading && !isAllowed) {
            navigate(redirectTo, { replace: true });
        }
    }, [loading, isAllowed, navigate, redirectTo]);
    if (loading) {
        return _jsx(Loading, { fullScreen: true });
    }
    if (!isAllowed) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
}
